module.exports = __webpack_public_path__ + "DINNextRoundedLTPro-Light.woff2?79c9b8489b77a2a7534b9bf87487e8e9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextRoundedLTPro-Light.woff2
// module id = 1391
// module chunks = 0